/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum AccountTypeEnum {
  Admin = "Admin",
  Manager = "Manager",
  Consultant = "Consultant",
  Assistant = "Assistant",
  Client = "Client",
}

export enum ActivityType {
  Record = "Record",
  Comment = "Comment",
}

export enum AggregationEnum {
  Count = "count",
  Avg = "avg",
  Sum = "sum",
}

export interface AggregationModel {
  predicates?: PredicateDefinition[] | null;
  aggregation?: AggregationEnum;
  aggregationProperty?: string | null;
}

export interface AggregationResponse {
  result?: IActionResult;
}

export interface AggregationResponseApiResultSuccess {
  returnValue?: AggregationResponse;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ApiResultBase {
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ApiResultException {
  message?: string | null;
  stackTrace?: string | null;
  error?: ApiResultException;
}

export interface ApiResultFailed {
  returnValue?: Null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ApplicationUser {
  firstName?: string | null;
  lastName?: string | null;
  language?: string | null;
  id?: string | null;
  userName?: string | null;
  normalizedUserName?: string | null;
  email?: string | null;
  normalizedEmail?: string | null;
  emailConfirmed?: boolean;
  passwordHash?: string | null;
  securityStamp?: string | null;
  concurrencyStamp?: string | null;
  phoneNumber?: string | null;
  phoneNumberConfirmed?: boolean;
  twoFactorEnabled?: boolean;

  /** @format date-time */
  lockoutEnd?: string | null;
  lockoutEnabled?: boolean;

  /** @format int32 */
  accessFailedCount?: number;
}

export interface ApplicationUserModel {
  /** @format date-time */
  createdAt?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  language?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  twoFactorEnabled?: boolean;

  /** @format uuid */
  partyId?: string | null;
  clientCode?: string | null;

  /** @format uuid */
  clientStateId?: string;
  clientState?: CodebookModel;
  accountType?: AccountTypeEnum;
  emailInvestmentComments?: boolean;
  emailComments?: boolean;
  emailNotifications?: boolean;
  emailTaskDate?: boolean;
  emailEventDate?: boolean;
  emailNotification?: boolean;
  emailClientNotification?: boolean;
  emailTaskNotification?: boolean;
  emailEventNotification?: boolean;
  emailArticleNotification?: boolean;
  calendarLink?: string | null;
  avatar?: string | null;

  /** @format date-time */
  lastLoginAt?: string;

  /** @format date-time */
  lastArticleCheckAt?: string | null;

  /** @format uuid */
  id?: string;
}

export interface ApplicationUserModelApiResultSuccess {
  returnValue?: ApplicationUserModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ArticleActivityModel {
  /** @format uuid */
  articleId?: string;
  article?: ArticleModel;
  createdBy?: PartyBaseModel;
  description?: string | null;
  type?: ActivityType;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface ArticleActivityModelApiResultSuccess {
  returnValue?: ArticleActivityModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ArticleActivityModelIEnumerableApiResultSuccess {
  returnValue?: ArticleActivityModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ArticleBaseModel {
  createdBy?: PartyBaseModel;
  name?: string | null;

  /** @format int32 */
  commentCount?: number;

  /** @format int32 */
  fileCount?: number;

  /** @format int32 */
  readCount?: number;
  isPublished?: boolean;

  /** @format date-time */
  publishedAt?: string | null;

  /** @format uuid */
  articleTypeId?: string | null;
  articleType?: CodebookModel;
  isSentToClient?: boolean;
  canSendToClient?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface ArticleModel {
  content?: string | null;
  contentPreview?: string | null;
  createdBy?: PartyBaseModel;
  name?: string | null;

  /** @format int32 */
  commentCount?: number;

  /** @format int32 */
  fileCount?: number;

  /** @format int32 */
  readCount?: number;
  isPublished?: boolean;

  /** @format date-time */
  publishedAt?: string | null;

  /** @format uuid */
  articleTypeId?: string | null;
  articleType?: CodebookModel;
  isSentToClient?: boolean;
  canSendToClient?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface ArticleModelApiResultSuccess {
  returnValue?: ArticleModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ArticleModelIEnumerableApiResultSuccess {
  returnValue?: ArticleModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ArticleReadingModel {
  /** @format uuid */
  articleId?: string;
  article?: ArticleBaseModel;

  /** @format uuid */
  partyId?: string;
  party?: PartyBaseModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface ArticleReadingModelApiResultSuccess {
  returnValue?: ArticleReadingModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ArticleReadingModelIEnumerableApiResultSuccess {
  returnValue?: ArticleReadingModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface AvatarUploadModel {
  contentType?: string | null;
  base64?: string | null;
}

export interface CodebookModel {
  type?: CodebookType;
  name?: string | null;

  /** @format int32 */
  position?: number;
  color?: string | null;
  defaultValue?: boolean | null;

  /** @format uuid */
  productId?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface CodebookModelApiResultSuccess {
  returnValue?: CodebookModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CodebookModelIEnumerableApiResultSuccess {
  returnValue?: CodebookModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum CodebookType {
  ClientState = "ClientState",
  NotificationType = "NotificationType",
  EventType = "EventType",
  TaskType = "TaskType",
  TaskState = "TaskState",
  TaskPriority = "TaskPriority",
  InvestmentStrategyType = "InvestmentStrategyType",
  InsuraceCompany = "InsuraceCompany",
  BankType = "BankType",
  LoanType = "LoanType",
  MaritalStatus = "MaritalStatus",
  Nationality = "Nationality",
  ArticleType = "ArticleType",
}

export enum ConditionalQueryOperator {
  Eq = "eq",
  Ne = "ne",
  Gt = "gt",
  Gte = "gte",
  Lt = "lt",
  Lte = "lte",
}

export interface ConfirmEmailModel {
  /** @format email */
  email: string;
  token?: string | null;
}

export interface ConfirmResetPasswordModel {
  /** @format email */
  email: string;
  token?: string | null;

  /** @format password */
  password: string;
}

export interface ConversionExchangeRateModel {
  isPublic?: boolean;

  /** @format date-time */
  date?: string;

  /** @format uuid */
  fromCurrencyId?: string;
  fromCurrency?: CurrencyModel;

  /** @format uuid */
  toCurrencyId?: string;
  toCurrency?: CurrencyModel;

  /** @format date-time */
  fromDate?: string;

  /** @format date-time */
  toDate?: string;

  /** @format double */
  rate?: number;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface ConversionExchangeRateModelApiResultSuccess {
  returnValue?: ConversionExchangeRateModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ConversionExchangeRateModelIEnumerableApiResultSuccess {
  returnValue?: ConversionExchangeRateModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum ConvertFunctionEnum {
  None = "none",
  Date = "date",
  Day = "day",
  Month = "month",
  Year = "year",
  Hour = "hour",
  Minute = "minute",
  Second = "second",
}

export enum CreditStateEnum {
  WaitingForApproval = "WaitingForApproval",
  Approved = "Approved",
}

export interface CurrencyModel {
  name?: string | null;
  shortName?: string | null;
  isActive?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface CurrencyModelApiResultSuccess {
  returnValue?: CurrencyModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CurrencyModelIEnumerableApiResultSuccess {
  returnValue?: CurrencyModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum DirectionEnum {
  In = "In",
  Out = "Out",
}

export interface EventBaseModel {
  name?: string | null;

  /** @format uuid */
  eventTypeId?: string;
  eventType?: CodebookModel;

  /** @format uuid */
  partyId?: string | null;
  party?: PartyBaseModel;

  /** @format date-time */
  start?: string;

  /** @format date-time */
  end?: string;
  color?: string | null;
  externalSystemId?: string | null;
  entityId?: string | null;
  action?: NotificationAction;
  isPublic?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface EventModel {
  description?: string | null;
  eventParticipants?: EventParticipantModel[] | null;
  name?: string | null;

  /** @format uuid */
  eventTypeId?: string;
  eventType?: CodebookModel;

  /** @format uuid */
  partyId?: string | null;
  party?: PartyBaseModel;

  /** @format date-time */
  start?: string;

  /** @format date-time */
  end?: string;
  color?: string | null;
  externalSystemId?: string | null;
  entityId?: string | null;
  action?: NotificationAction;
  isPublic?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface EventModelApiResultSuccess {
  returnValue?: EventModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface EventModelIEnumerableApiResultSuccess {
  returnValue?: EventModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface EventParticipantModel {
  /** @format uuid */
  eventId?: string;
  event?: EventBaseModel;

  /** @format uuid */
  partyId?: string;
  party?: PartyBaseModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface EventParticipantModelApiResultSuccess {
  returnValue?: EventParticipantModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface EventParticipantModelIEnumerableApiResultSuccess {
  returnValue?: EventParticipantModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ExchangeRateModel {
  type?: ExchangeRateTypeEnum;
  isPublic?: boolean;

  /** @format date-time */
  date?: string;

  /** @format uuid */
  productId?: string | null;

  /** @format date-time */
  fromDate?: string;

  /** @format date-time */
  toDate?: string;

  /** @format uuid */
  fromCurrencyId?: string | null;
  fromCurrency?: CurrencyModel;

  /** @format uuid */
  toCurrencyId?: string | null;
  toCurrency?: CurrencyModel;

  /** @format double */
  rate?: number;

  /** @format double */
  valueFiat?: number | null;

  /** @format double */
  valueWallets?: number | null;

  /** @format double */
  secondaryRate?: number | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface ExchangeRateModelApiResultSuccess {
  returnValue?: ExchangeRateModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ExchangeRateModelIEnumerableApiResultSuccess {
  returnValue?: ExchangeRateModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum ExchangeRateTypeEnum {
  Product = "Product",
  Currency = "Currency",
}

export interface FileActivityModel {
  /** @format uuid */
  fileId?: string;
  file?: FileModel;
  createdBy?: PartyBaseModel;
  description?: string | null;
  type?: ActivityType;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface FileActivityModelApiResultSuccess {
  returnValue?: FileActivityModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface FileActivityModelIEnumerableApiResultSuccess {
  returnValue?: FileActivityModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface FileCopyModel {
  /** @format uuid */
  fileId?: string;

  /** @format uuid */
  copyToFolderId?: string;
}

export interface FileDownloadModel {
  filename?: string | null;
  contentType?: string | null;
  base64?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface FileDownloadModelApiResultSuccess {
  returnValue?: FileDownloadModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface FileModel {
  /** @format uuid */
  ownerId?: string | null;
  owner?: PartyBaseModel;

  /** @format uuid */
  folderId?: string | null;

  /** @format uuid */
  partyId?: string | null;
  party?: PartyBaseModel;

  /** @format uuid */
  partyProductId?: string | null;
  partyProduct?: PartyProductBaseModel;

  /** @format uuid */
  userTaskId?: string | null;
  userTask?: UserTaskBaseModel;

  /** @format uuid */
  articleId?: string | null;
  article?: ArticleBaseModel;
  description?: string | null;
  fileName?: string | null;

  /** @format int64 */
  fileSize?: number;
  contentType?: string | null;
  blobName?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface FileModelApiResultSuccess {
  returnValue?: FileModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface FileModelIEnumerableApiResultSuccess {
  returnValue?: FileModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface FolderBaseModel {
  name?: string | null;
  entityType?: FolderEntityTypeEnum;

  /** @format uuid */
  entityId?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export enum FolderEntityTypeEnum {
  Root = "Root",
  Party = "Party",
  Task = "Task",
  General = "General",
  Article = "Article",
}

export interface FolderModel {
  /** @format uuid */
  parentId?: string | null;
  parent?: FolderBaseModel;
  children?: FolderBaseModel[] | null;
  name?: string | null;
  entityType?: FolderEntityTypeEnum;

  /** @format uuid */
  entityId?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface FolderModelApiResultSuccess {
  returnValue?: FolderModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface FolderModelIEnumerableApiResultSuccess {
  returnValue?: FolderModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface GroupByDefinition {
  field?: string | null;
  convert?: ConvertFunctionEnum;
}

export interface GroupByProjectionDefinition {
  field?: string | null;
  aggregation?: ProjectionAggregationEnum;
  outputField?: string | null;
  conditional?: boolean;
  op?: ConditionalQueryOperator;
  comparand?: any;
}

export interface GrouppedQueryModel {
  groupby?: GroupByDefinition[] | null;
  projections?: GroupByProjectionDefinition[] | null;
  predicates?: PredicateDefinition[] | null;
  orderby?: OrderByDefinition[] | null;
  joins?: JoinDefinition[] | null;
}

export enum HttpStatusCode {
  Continue = "Continue",
  SwitchingProtocols = "SwitchingProtocols",
  Processing = "Processing",
  EarlyHints = "EarlyHints",
  OK = "OK",
  Created = "Created",
  Accepted = "Accepted",
  NonAuthoritativeInformation = "NonAuthoritativeInformation",
  NoContent = "NoContent",
  ResetContent = "ResetContent",
  PartialContent = "PartialContent",
  MultiStatus = "MultiStatus",
  AlreadyReported = "AlreadyReported",
  IMUsed = "IMUsed",
  Ambiguous = "Ambiguous",
  Moved = "Moved",
  Redirect = "Redirect",
  RedirectMethod = "RedirectMethod",
  NotModified = "NotModified",
  UseProxy = "UseProxy",
  Unused = "Unused",
  TemporaryRedirect = "TemporaryRedirect",
  PermanentRedirect = "PermanentRedirect",
  BadRequest = "BadRequest",
  Unauthorized = "Unauthorized",
  PaymentRequired = "PaymentRequired",
  Forbidden = "Forbidden",
  NotFound = "NotFound",
  MethodNotAllowed = "MethodNotAllowed",
  NotAcceptable = "NotAcceptable",
  ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
  RequestTimeout = "RequestTimeout",
  Conflict = "Conflict",
  Gone = "Gone",
  LengthRequired = "LengthRequired",
  PreconditionFailed = "PreconditionFailed",
  RequestEntityTooLarge = "RequestEntityTooLarge",
  RequestUriTooLong = "RequestUriTooLong",
  UnsupportedMediaType = "UnsupportedMediaType",
  RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
  ExpectationFailed = "ExpectationFailed",
  MisdirectedRequest = "MisdirectedRequest",
  UnprocessableEntity = "UnprocessableEntity",
  Locked = "Locked",
  FailedDependency = "FailedDependency",
  UpgradeRequired = "UpgradeRequired",
  PreconditionRequired = "PreconditionRequired",
  TooManyRequests = "TooManyRequests",
  RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
  UnavailableForLegalReasons = "UnavailableForLegalReasons",
  InternalServerError = "InternalServerError",
  NotImplemented = "NotImplemented",
  BadGateway = "BadGateway",
  ServiceUnavailable = "ServiceUnavailable",
  GatewayTimeout = "GatewayTimeout",
  HttpVersionNotSupported = "HttpVersionNotSupported",
  VariantAlsoNegotiates = "VariantAlsoNegotiates",
  InsufficientStorage = "InsufficientStorage",
  LoopDetected = "LoopDetected",
  NotExtended = "NotExtended",
  NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export type IActionResult = object;

export interface IdentityError {
  code?: string | null;
  description?: string | null;
}

export interface IdentityResult {
  succeeded?: boolean;
  errors?: IdentityError[] | null;
}

export interface JoinDefinition {
  entity?: string | null;
  predicates?: PredicateDefinition[] | null;
  left?: string | null;
  right?: string | null;
}

export enum JunctionOperator {
  And = "and",
  Or = "or",
}

export enum NotificationAction {
  ClientRequest = "ClientRequest",
  ClientBirthday = "ClientBirthday",
  ProductAnniversary = "ProductAnniversary",
}

export interface NotificationModel {
  name?: string | null;

  /** @format uuid */
  notificationTypeId?: string;
  notificationType?: CodebookModel;

  /** @format uuid */
  partyId?: string | null;
  party?: PartyBaseModel;

  /** @format uuid */
  ownerId?: string;
  owner?: PartyBaseModel;

  /** @format date-time */
  time?: string;

  /** @format uuid */
  partyProductId?: string | null;
  partyProduct?: PartyProductBaseModel;
  description?: string | null;
  isConfirmed?: boolean;
  action?: NotificationAction;
  automaticNotification?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface NotificationModelApiResultSuccess {
  returnValue?: NotificationModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface NotificationModelIEnumerableApiResultSuccess {
  returnValue?: NotificationModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum NotificationRuleAction {
  ContractEnd = "ContractEnd",
  ContractSigned = "ContractSigned",
  FixationEnd = "FixationEnd",
}

export enum NotificationRuleActionType {
  Before = "Before",
  After = "After",
}

export interface NreiGoogleSheetModel {
  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface NreiGoogleSheetModelApiResultSuccess {
  returnValue?: NreiGoogleSheetModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export type Null = object;

export interface ObjectIEnumerableApiResultSuccess {
  returnValue?: any[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface Operation {
  value?: any;
  path?: string | null;
  op?: string | null;
  from?: string | null;
}

export enum OpResultStatus {
  None = "none",
  Succeeded = "succeeded",
  Canceled = "canceled",
  Faulted = "faulted",
}

export interface OrderByDefinition {
  field?: string | null;

  /** @format int32 */
  index?: number | null;
  order?: SortOrder;
}

export interface PartyActivityModel {
  /** @format uuid */
  partyId?: string;
  party?: PartyBaseModel;
  createdBy?: PartyBaseModel;
  description?: string | null;
  type?: ActivityType;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface PartyActivityModelApiResultSuccess {
  returnValue?: PartyActivityModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyActivityModelIEnumerableApiResultSuccess {
  returnValue?: PartyActivityModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyBaseModel {
  avatar?: string | null;

  /** @format uuid */
  userId?: string | null;
  clientCode?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
  phoneNumber?: string | null;

  /** @format uuid */
  ownerId?: string | null;
  emailInvestmentComments?: boolean;
  emailComments?: boolean;
  emailNotifications?: boolean;
  emailTaskDate?: boolean;
  emailEventDate?: boolean;
  emailNotification?: boolean | null;
  emailClientNotification?: boolean | null;
  emailTaskNotification?: boolean | null;
  emailEventNotification?: boolean | null;
  emailArticleNotification?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface PartyCreditModel {
  /** @format date-time */
  date?: string;

  /** @format uuid */
  partyId?: string;
  party?: PartyBaseModel;

  /** @format int32 */
  quantity?: number;

  /** @format int32 */
  quantityReal?: number;
  direction?: DirectionEnum;
  creditState?: CreditStateEnum;
  description?: string | null;
  createdBy?: PartyBaseModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface PartyCreditModelApiResultSuccess {
  returnValue?: PartyCreditModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyCreditModelIEnumerableApiResultSuccess {
  returnValue?: PartyCreditModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyCreditUploadModel {
  contentType?: string | null;
  base64?: string | null;
}

export interface PartyChildModel {
  /** @format uuid */
  partyId?: string;
  firstName?: string | null;
  lastName?: string | null;
  personalIdentificationNumber?: string | null;

  /** @format date-time */
  birthdate?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface PartyModel {
  birthplace?: string | null;
  profession?: string | null;
  personalIdentificationNumber?: string | null;

  /** @format date-time */
  birthdate?: string | null;
  residenceAddressStreet?: string | null;
  residenceAddressCity?: string | null;
  residenceAddressCountry?: string | null;
  residenceAddressZip?: string | null;
  isSameCorrespondenceAddress?: boolean;
  correspondenceAddressStreet?: string | null;
  correspondenceAddressCity?: string | null;
  correspondenceAddressCountry?: string | null;
  correspondenceAddressZip?: string | null;
  bankAccount?: string | null;

  /** @format uuid */
  clientStateId?: string;
  clientState?: CodebookModel;
  accountType?: AccountTypeEnum;
  owner?: PartyBaseModel;

  /** @format int32 */
  productsCount?: number;
  identityCardNumber?: string | null;

  /** @format date-time */
  identityCardIssueDate?: string | null;

  /** @format date-time */
  identityCardExpirationDate?: string | null;
  identityCardIssuer?: string | null;
  driverLicenceNumber?: string | null;

  /** @format date-time */
  driverLicenceIssueDate?: string | null;

  /** @format date-time */
  driverLicenceExpirationDate?: string | null;
  driverLicenceIssuer?: string | null;
  calendarLink?: string | null;
  createdBy?: PartyBaseModel;
  smoker?: boolean;
  injuriesInSevenYears?: string | null;
  illness?: string | null;
  medicaments?: string | null;
  sport?: string | null;
  sex?: string | null;

  /** @format uuid */
  maritalStatusId?: string | null;
  maritalStatus?: CodebookModel;

  /** @format uuid */
  nationalityId?: string | null;
  nationality?: CodebookModel;
  vat?: string | null;
  identificationNumber?: string | null;
  registrationEmailSent?: boolean;
  isArchived?: boolean;

  /** @format int32 */
  totalCredits?: number | null;
  isCreditMessageShown?: boolean | null;
  companyName?: string | null;
  companyAddressStreet?: string | null;
  companyAddressCity?: string | null;
  companyAddressCountry?: string | null;
  companyAddressZip?: string | null;

  /** @format double */
  height?: number | null;

  /** @format double */
  weight?: number | null;

  /** @format date-time */
  lastLoginAt?: string | null;

  /** @format date-time */
  lastArticleCheckAt?: string | null;
  partyType?: PartyTypeEnum;
  executiveFirstName?: string | null;
  executiveLastName?: string | null;
  executivePhone?: string | null;
  executiveEmail?: string | null;
  children?: PartyChildModel[] | null;
  avatar?: string | null;

  /** @format uuid */
  userId?: string | null;
  clientCode?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
  phoneNumber?: string | null;

  /** @format uuid */
  ownerId?: string | null;
  emailInvestmentComments?: boolean;
  emailComments?: boolean;
  emailNotifications?: boolean;
  emailTaskDate?: boolean;
  emailEventDate?: boolean;
  emailNotification?: boolean | null;
  emailClientNotification?: boolean | null;
  emailTaskNotification?: boolean | null;
  emailEventNotification?: boolean | null;
  emailArticleNotification?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface PartyModelApiResultSuccess {
  returnValue?: PartyModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyModelIEnumerableApiResultSuccess {
  returnValue?: PartyModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyProductBaseModel {
  name?: string | null;
  isActive?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface PartyProductInterestRateModel {
  /** @format uuid */
  partyProductId?: string;

  /** @format date-time */
  fromDate?: string;

  /** @format date-time */
  toDate?: string | null;

  /** @format double */
  interestRate?: number;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface PartyProductModel {
  name?: string | null;
  isActive?: boolean;
  party?: PartyBaseModel;

  /** @format uuid */
  partyId?: string;

  /** @format uuid */
  productId?: string;

  /** @format date-time */
  dateOfSignature?: string | null;

  /** @format date-time */
  dateOfStart?: string | null;

  /** @format date-time */
  dateOfEnding?: string | null;

  /** @format uuid */
  insuarenceCompanyId?: string | null;
  insuarenceCompany?: CodebookModel;

  /** @format uuid */
  bankCompanyId?: string | null;
  bankCompany?: CodebookModel;

  /** @format double */
  insurancePrice?: number | null;
  description?: string | null;

  /** @format double */
  depositAmount?: number | null;

  /** @format double */
  monthlyRevenue?: number | null;
  revenueAmount?: string | null;
  pickAmount?: string | null;

  /** @format double */
  definedRevenue?: number | null;

  /** @format double */
  currentCapitalAmount?: number | null;

  /** @format double */
  loanAmount?: number | null;

  /** @format double */
  monthlyPrice?: number | null;

  /** @format double */
  sources?: number | null;

  /** @format double */
  interestRate?: number | null;
  investmentStrategy?: CodebookModel;

  /** @format uuid */
  investmentStrategyId?: string | null;

  /** @format double */
  monthlyContribution?: number | null;

  /** @format double */
  targetAmount?: number | null;
  productFounder?: ProductFounder;
  projectAddress?: string | null;
  mortgagedPropertyAddress?: string | null;

  /** @format double */
  rpsn?: number | null;

  /** @format uuid */
  loanTypeId?: string | null;
  loanType?: CodebookModel;

  /** @format double */
  totalDeposit?: number;

  /** @format double */
  totalEarnings?: number | null;

  /** @format double */
  currentStateOfCapital?: number | null;
  priceType?: PriceTypeEnum;

  /** @format date-time */
  anniversary?: string | null;
  isPeriodical?: boolean | null;
  isOneTime?: boolean | null;

  /** @format double */
  investedAmount?: number | null;

  /** @format double */
  takenAmount?: number | null;

  /** @format double */
  takenAmountFromEvaluation?: number | null;

  /** @format double */
  initialEvaluation?: number | null;
  partyProductCode?: string | null;
  partyProductName?: string | null;
  partyProductInterestRates?: PartyProductInterestRateModel[] | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface PartyProductModelApiResultSuccess {
  returnValue?: PartyProductModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyProductModelIEnumerableApiResultSuccess {
  returnValue?: PartyProductModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PartyProductQuotationModel {
  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface PartyProductQuotationModelApiResultSuccess {
  returnValue?: PartyProductQuotationModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum PartyTypeEnum {
  Individual = "Individual",
  Company = "Company",
}

export interface PredicateDefinition {
  junction?: JunctionOperator;
  field?: string | null;
  op?: QueryOperator;
  comparand?: any;
}

export enum PriceTypeEnum {
  Monthly = "Monthly",
  Yearly = "Yearly",
}

export interface ProductActivityModel {
  /** @format uuid */
  productId?: string;
  product?: ProductModel;
  createdBy?: PartyBaseModel;
  description?: string | null;
  type?: ActivityType;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface ProductActivityModelApiResultSuccess {
  returnValue?: ProductActivityModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ProductActivityModelIEnumerableApiResultSuccess {
  returnValue?: ProductActivityModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum ProductFounder {
  NFG = "NFG",
  Other = "Other",
}

export interface ProductModel {
  name?: string | null;
  isActive?: boolean;

  /** @format uuid */
  productTypeId?: string;
  productType?: ProductTypeModel;

  /** @format double */
  exchangeRate?: number | null;

  /** @format date-time */
  startDate?: string | null;

  /** @format date-time */
  endDate?: string | null;

  /** @format int32 */
  shareCount?: number | null;
  isHidden?: boolean | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface ProductModelApiResultSuccess {
  returnValue?: ProductModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ProductModelIEnumerableApiResultSuccess {
  returnValue?: ProductModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ProductNotificationRuleModel {
  name?: string | null;
  product?: ProductModel;

  /** @format uuid */
  productId?: string;
  actionType?: NotificationRuleActionType;
  action?: NotificationRuleAction;

  /** @format int32 */
  numberOfDays?: number;
  isActive?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface ProductNotificationRuleModelApiResultSuccess {
  returnValue?: ProductNotificationRuleModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ProductNotificationRuleModelIEnumerableApiResultSuccess {
  returnValue?: ProductNotificationRuleModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ProductTypeModel {
  name?: string | null;
  systemProduct?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface ProductTypeModelApiResultSuccess {
  returnValue?: ProductTypeModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ProductTypeModelIEnumerableApiResultSuccess {
  returnValue?: ProductTypeModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum ProjectionAggregationEnum {
  Count = "count",
  Avg = "avg",
  Sum = "sum",
  Min = "min",
  Max = "max",
}

export interface QueryModel {
  predicates?: PredicateDefinition[] | null;
  orderby?: OrderByDefinition[] | null;
  joins?: JoinDefinition[] | null;
}

export enum QueryOperator {
  Eq = "eq",
  Ne = "ne",
  Gt = "gt",
  Gte = "gte",
  Lt = "lt",
  Lte = "lte",
  C = "c",
  Sw = "sw",
  Ew = "ew",
  In = "in",
  Wrap = "wrap",
}

export interface ResetPasswordModel {
  /** @format email */
  email: string;
}

export interface SendPartyRegistrationModel {
  /** @format uuid */
  id?: string;
}

export interface SetPasswordModel {
  currentPassword: string;
  newPassword: string;
}

export interface ShareLogModel {
  createdBy?: PartyBaseModel;

  /** @format uuid */
  shareId?: string;
  share?: ShareModel;
  type?: ShareLogTypeEnum;

  /** @format uuid */
  fromOwnerId?: string | null;
  fromOwner?: PartyProductModel;

  /** @format uuid */
  toOwnerId?: string | null;
  toOwner?: PartyProductModel;

  /** @format uuid */
  tradeId?: string | null;
  trade?: TradeBasicModel;

  /** @format uuid */
  walletTransactionId?: string | null;
  walletTransaction?: WalletTransactionModel;

  /** @format int32 */
  evidenceNumber?: number;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface ShareLogModelApiResultSuccess {
  returnValue?: ShareLogModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ShareLogModelIEnumerableApiResultSuccess {
  returnValue?: ShareLogModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum ShareLogTypeEnum {
  Buy = "Buy",
  Sell = "Sell",
  Transfer = "Transfer",
}

export interface ShareModel {
  /** @format uuid */
  productId?: string;
  product?: ProductModel;

  /** @format int32 */
  evidenceNumber?: number;

  /** @format uuid */
  ownerId?: string | null;
  owner?: PartyProductModel;

  /** @format date-time */
  soldAt?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface ShareModelApiResultSuccess {
  returnValue?: ShareModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ShareModelIEnumerableApiResultSuccess {
  returnValue?: ShareModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

export interface StateOfCapitalModel {
  /** @format date-time */
  date?: string;

  /** @format uuid */
  productId?: string;

  /** @format double */
  value?: number;

  /** @format double */
  investmentValue?: number;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface StateOfCapitalModelApiResultSuccess {
  returnValue?: StateOfCapitalModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface StateOfCapitalModelIEnumerableApiResultSuccess {
  returnValue?: StateOfCapitalModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface StateOfCapitalYearModel {
  /** @format date-time */
  date?: string;

  /** @format uuid */
  productId?: string;

  /** @format double */
  value?: number;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface StateOfCapitalYearModelApiResultSuccess {
  returnValue?: StateOfCapitalYearModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface StateOfCapitalYearModelIEnumerableApiResultSuccess {
  returnValue?: StateOfCapitalYearModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface SubTaskModel {
  /** @format uuid */
  userTaskId?: string;
  description?: string | null;
  isChecked?: boolean;

  /** @format int32 */
  position?: number | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface TradeBasicModel {
  createdBy?: PartyBaseModel;
  type?: TradeTypeEnum;

  /** @format uuid */
  partyProductId?: string | null;
  partyProduct?: PartyProductModel;

  /** @format uuid */
  fromPartyProductId?: string | null;
  fromPartyProduct?: PartyProductModel;

  /** @format date-time */
  time?: string;

  /** @format uuid */
  fromCurrencyId?: string;
  fromCurrency?: CurrencyModel;

  /** @format uuid */
  toCurrencyId?: string;
  toCurrency?: CurrencyModel;

  /** @format double */
  fromAmount?: number;

  /** @format double */
  toAmount?: number;
  shares?: string[] | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface TradeConversionModel {
  /** @format uuid */
  tradeId?: string;
  trade?: TradeBasicModel;

  /** @format uuid */
  exchangeRateId?: string;
  exchangeRate?: ExchangeRateModel;

  /** @format double */
  fromAmount?: number;

  /** @format double */
  toAmount?: number;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface TradeModel {
  tradeConversions?: TradeConversionModel[] | null;
  createdBy?: PartyBaseModel;
  type?: TradeTypeEnum;

  /** @format uuid */
  partyProductId?: string | null;
  partyProduct?: PartyProductModel;

  /** @format uuid */
  fromPartyProductId?: string | null;
  fromPartyProduct?: PartyProductModel;

  /** @format date-time */
  time?: string;

  /** @format uuid */
  fromCurrencyId?: string;
  fromCurrency?: CurrencyModel;

  /** @format uuid */
  toCurrencyId?: string;
  toCurrency?: CurrencyModel;

  /** @format double */
  fromAmount?: number;

  /** @format double */
  toAmount?: number;
  shares?: string[] | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface TradeModelApiResultSuccess {
  returnValue?: TradeModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TradeModelIEnumerableApiResultSuccess {
  returnValue?: TradeModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TradeRequest {
  /** @format uuid */
  partyProductId?: string;

  /** @format uuid */
  fromCurrencyId?: string;

  /** @format uuid */
  toCurrencyId?: string;

  /** @format double */
  amount?: number;
}

export enum TradeTypeEnum {
  Buy = "Buy",
  Sell = "Sell",
  Transfer = "Transfer",
}

export interface TransactionEmailModel {
  type?: TransactionEmailType;

  /** @format uuid */
  userId?: string;
  user?: ApplicationUser;

  /** @format uuid */
  partyId?: string | null;
  party?: PartyBaseModel;

  /** @format uuid */
  userTaskId?: string | null;
  userTask?: UserTaskBaseModel;

  /** @format uuid */
  eventId?: string | null;
  event?: EventBaseModel;
  isSent?: boolean;

  /** @format date-time */
  sentAt?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface TransactionEmailModelApiResultSuccess {
  returnValue?: TransactionEmailModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TransactionEmailModelIEnumerableApiResultSuccess {
  returnValue?: TransactionEmailModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum TransactionEmailType {
  ClientAdded = "ClientAdded",
  ClientUpdated = "ClientUpdated",
  UserTaskAdded = "UserTaskAdded",
  UserTaskUpdated = "UserTaskUpdated",
  UserTaskDeleted = "UserTaskDeleted",
  UserTaskAddedComment = "UserTaskAddedComment",
  UserTaskUpdatedComment = "UserTaskUpdatedComment",
  UserTaskDeletedComment = "UserTaskDeletedComment",
  EventAdded = "EventAdded",
  EventUpdated = "EventUpdated",
  EventDeleted = "EventDeleted",
}

export interface TransactionModel {
  /** @format date-time */
  time?: string;

  /** @format uuid */
  partyProductId?: string;
  partyProduct?: PartyProductBaseModel;

  /** @format uuid */
  partyId?: string;
  party?: PartyBaseModel;

  /** @format double */
  deposit?: number;

  /** @format double */
  earnings?: number;

  /** @format double */
  interestRate?: number;

  /** @format double */
  withdrawal?: number;

  /** @format double */
  stateOfCapital?: number;

  /** @format uuid */
  exchangeRateId?: string | null;
  exchangeRate?: ExchangeRateModel;

  /** @format double */
  share?: number | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface TransactionModelApiResultSuccess {
  returnValue?: TransactionModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TransactionModelIEnumerableApiResultSuccess {
  returnValue?: TransactionModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface UpdateLogModel {
  /** @format uuid */
  entityId?: string;
  state?: UpdateState;

  /** @format date-time */
  time?: string;
  createdBy?: PartyBaseModel;
  description?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface UpdateLogModelApiResultSuccess {
  returnValue?: UpdateLogModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface UpdateLogModelIEnumerableApiResultSuccess {
  returnValue?: UpdateLogModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum UpdateState {
  Waiting = "Waiting",
  Running = "Running",
  Success = "Success",
  Fail = "Fail",
}

export interface UserTaskActivityModel {
  /** @format uuid */
  userTaskId?: string;
  userTask?: UserTaskBaseModel;
  createdBy?: PartyBaseModel;
  description?: string | null;
  type?: ActivityType;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface UserTaskActivityModelApiResultSuccess {
  returnValue?: UserTaskActivityModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface UserTaskActivityModelIEnumerableApiResultSuccess {
  returnValue?: UserTaskActivityModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface UserTaskBaseModel {
  name?: string | null;

  /** @format date-time */
  taskDate?: string;

  /** @format date-time */
  resolvedAt?: string | null;

  /** @format uuid */
  taskTypeId?: string;
  taskType?: CodebookModel;

  /** @format uuid */
  taskStateId?: string;
  taskState?: CodebookModel;

  /** @format uuid */
  priorityId?: string;
  priority?: CodebookModel;

  /** @format uuid */
  partyId?: string | null;
  party?: PartyBaseModel;

  /** @format uuid */
  ownerId?: string;
  owner?: PartyBaseModel;
  isArchived?: boolean;

  /** @format int32 */
  commentCount?: number | null;

  /** @format int32 */
  fileCount?: number | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface UserTaskModel {
  assignmentDescription?: string | null;
  solutionDescription?: string | null;
  userTaskActivities?: UserTaskActivityModel[] | null;
  subTasks?: SubTaskModel[] | null;
  userTaskSolvers?: UserTaskSolverModel[] | null;
  name?: string | null;

  /** @format date-time */
  taskDate?: string;

  /** @format date-time */
  resolvedAt?: string | null;

  /** @format uuid */
  taskTypeId?: string;
  taskType?: CodebookModel;

  /** @format uuid */
  taskStateId?: string;
  taskState?: CodebookModel;

  /** @format uuid */
  priorityId?: string;
  priority?: CodebookModel;

  /** @format uuid */
  partyId?: string | null;
  party?: PartyBaseModel;

  /** @format uuid */
  ownerId?: string;
  owner?: PartyBaseModel;
  isArchived?: boolean;

  /** @format int32 */
  commentCount?: number | null;

  /** @format int32 */
  fileCount?: number | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface UserTaskModelApiResultSuccess {
  returnValue?: UserTaskModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface UserTaskModelIEnumerableApiResultSuccess {
  returnValue?: UserTaskModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface UserTaskSolverModel {
  /** @format uuid */
  userTaskId?: string;

  /** @format uuid */
  partyId?: string;
  party?: PartyBaseModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface WalletModel {
  /** @format uuid */
  currencyId?: string;
  currency?: CurrencyModel;

  /** @format uuid */
  partyProductId?: string | null;
  partyProduct?: PartyProductModel;

  /** @format double */
  currentValue?: number;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface WalletModelApiResultSuccess {
  returnValue?: WalletModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WalletModelIEnumerableApiResultSuccess {
  returnValue?: WalletModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WalletTransactionModel {
  createdBy?: PartyBaseModel;

  /** @format uuid */
  walletId?: string;
  wallet?: WalletModel;

  /** @format date-time */
  time?: string;

  /** @format double */
  amount?: number;

  /** @format uuid */
  tradeId?: string | null;
  trade?: TradeModel;
  transactionType?: WalletTransactionTypeEnum;
  shares?: string[] | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface WalletTransactionModelApiResultSuccess {
  returnValue?: WalletTransactionModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WalletTransactionModelIEnumerableApiResultSuccess {
  returnValue?: WalletTransactionModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum WalletTransactionTypeEnum {
  Standard = "Standard",
  Reward = "Reward",
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        ...(requestParams.headers || {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Nordelo API
 * @version 1.0
 * @license MIT (https://opensource.org/licenses/MIT)
 * @contact Support <info@nordelo.cz>
 *
 * A REST API service with Swagger, Swashbuckle, and API versioning.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags ArticleActivities
     * @name DeleteArticleActivities
     * @request DELETE:/api/article-activities
     * @secure
     */
    deleteArticleActivities: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ArticleActivityModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-activities`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleActivities
     * @name InsertArticleActivity
     * @request POST:/api/article-activities
     * @secure
     */
    insertArticleActivity: (data: ArticleActivityModel, params: RequestParams = {}) =>
      this.request<ArticleActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-activities`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleActivities
     * @name GetArticleActivityById
     * @request GET:/api/article-activities/{id}
     * @secure
     */
    getArticleActivityById: (id: string, params: RequestParams = {}) =>
      this.request<ArticleActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-activities/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleActivities
     * @name PatchArticleActivity
     * @request PATCH:/api/article-activities/{id}
     * @secure
     */
    patchArticleActivity: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<ArticleActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-activities/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleActivities
     * @name UpdateArticleActivity
     * @request PUT:/api/article-activities/{id}
     * @secure
     */
    updateArticleActivity: (id: string, data: ArticleActivityModel, params: RequestParams = {}) =>
      this.request<ArticleActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-activities/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleActivities
     * @name AggregationArticleActivity
     * @request POST:/api/article-activities/aggregation
     * @secure
     */
    aggregationArticleActivity: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-activities/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleActivities
     * @name GetArticleActivityGroupped
     * @request POST:/api/article-activities/groupped
     * @secure
     */
    getArticleActivityGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-activities/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleActivities
     * @name GetArticleActivityBatch
     * @request POST:/api/article-activities/{pageIndex},{pageSize}
     * @secure
     */
    getArticleActivityBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ArticleActivityModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-activities/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleReadings
     * @name DeleteArticleReadings
     * @request DELETE:/api/article-readings
     * @secure
     */
    deleteArticleReadings: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ArticleReadingModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-readings`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleReadings
     * @name InsertArticleReading
     * @request POST:/api/article-readings
     * @secure
     */
    insertArticleReading: (data: ArticleReadingModel, params: RequestParams = {}) =>
      this.request<ArticleReadingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-readings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleReadings
     * @name GetArticleReadingById
     * @request GET:/api/article-readings/{id}
     * @secure
     */
    getArticleReadingById: (id: string, params: RequestParams = {}) =>
      this.request<ArticleReadingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-readings/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleReadings
     * @name PatchArticleReading
     * @request PATCH:/api/article-readings/{id}
     * @secure
     */
    patchArticleReading: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<ArticleReadingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-readings/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleReadings
     * @name UpdateArticleReading
     * @request PUT:/api/article-readings/{id}
     * @secure
     */
    updateArticleReading: (id: string, data: ArticleReadingModel, params: RequestParams = {}) =>
      this.request<ArticleReadingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-readings/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleReadings
     * @name AggregationArticleReading
     * @request POST:/api/article-readings/aggregation
     * @secure
     */
    aggregationArticleReading: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-readings/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleReadings
     * @name GetArticleReadingGroupped
     * @request POST:/api/article-readings/groupped
     * @secure
     */
    getArticleReadingGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-readings/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleReadings
     * @name GetArticleReadingBatch
     * @request POST:/api/article-readings/{pageIndex},{pageSize}
     * @secure
     */
    getArticleReadingBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ArticleReadingModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/article-readings/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Articles
     * @name DeleteArticles
     * @request DELETE:/api/articles
     * @secure
     */
    deleteArticles: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ArticleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/articles`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Articles
     * @name InsertArticle
     * @request POST:/api/articles
     * @secure
     */
    insertArticle: (data: ArticleModel, params: RequestParams = {}) =>
      this.request<ArticleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/articles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Articles
     * @name GetArticleById
     * @request GET:/api/articles/{id}
     * @secure
     */
    getArticleById: (id: string, params: RequestParams = {}) =>
      this.request<ArticleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/articles/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Articles
     * @name PatchArticle
     * @request PATCH:/api/articles/{id}
     * @secure
     */
    patchArticle: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<ArticleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/articles/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Articles
     * @name UpdateArticle
     * @request PUT:/api/articles/{id}
     * @secure
     */
    updateArticle: (id: string, data: ArticleModel, params: RequestParams = {}) =>
      this.request<ArticleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/articles/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Articles
     * @name AggregationArticle
     * @request POST:/api/articles/aggregation
     * @secure
     */
    aggregationArticle: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/articles/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Articles
     * @name GetArticleGroupped
     * @request POST:/api/articles/groupped
     * @secure
     */
    getArticleGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/articles/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Articles
     * @name GetArticleBatch
     * @request POST:/api/articles/{pageIndex},{pageSize}
     * @secure
     */
    getArticleBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ArticleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/articles/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name DeleteCodebooks
     * @request DELETE:/api/codebooks
     * @secure
     */
    deleteCodebooks: (data: QueryModel, params: RequestParams = {}) =>
      this.request<CodebookModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name InsertCodebook
     * @request POST:/api/codebooks
     * @secure
     */
    insertCodebook: (data: CodebookModel, params: RequestParams = {}) =>
      this.request<CodebookModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name GetCodebookById
     * @request GET:/api/codebooks/{id}
     * @secure
     */
    getCodebookById: (id: string, params: RequestParams = {}) =>
      this.request<CodebookModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name PatchCodebook
     * @request PATCH:/api/codebooks/{id}
     * @secure
     */
    patchCodebook: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<CodebookModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name UpdateCodebook
     * @request PUT:/api/codebooks/{id}
     * @secure
     */
    updateCodebook: (id: string, data: CodebookModel, params: RequestParams = {}) =>
      this.request<CodebookModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name AggregationCodebook
     * @request POST:/api/codebooks/aggregation
     * @secure
     */
    aggregationCodebook: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name GetCodebookGroupped
     * @request POST:/api/codebooks/groupped
     * @secure
     */
    getCodebookGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name GetCodebookBatch
     * @request POST:/api/codebooks/{pageIndex},{pageSize}
     * @secure
     */
    getCodebookBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<CodebookModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConversionExchangeRates
     * @name DeleteConversionExchangeRate
     * @request DELETE:/api/conversion-exchange-rates
     * @secure
     */
    deleteConversionExchangeRate: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ConversionExchangeRateModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/conversion-exchange-rates`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConversionExchangeRates
     * @name InsertConversionExchangeRate
     * @request POST:/api/conversion-exchange-rates
     * @secure
     */
    insertConversionExchangeRate: (data: ConversionExchangeRateModel, params: RequestParams = {}) =>
      this.request<ConversionExchangeRateModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/conversion-exchange-rates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConversionExchangeRates
     * @name GetConversionExchangeRateById
     * @request GET:/api/conversion-exchange-rates/{id}
     * @secure
     */
    getConversionExchangeRateById: (id: string, params: RequestParams = {}) =>
      this.request<ConversionExchangeRateModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/conversion-exchange-rates/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConversionExchangeRates
     * @name PatchConversionExchangeRate
     * @request PATCH:/api/conversion-exchange-rates/{id}
     * @secure
     */
    patchConversionExchangeRate: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<ConversionExchangeRateModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/conversion-exchange-rates/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConversionExchangeRates
     * @name UpdateConversionExchangeRate
     * @request PUT:/api/conversion-exchange-rates/{id}
     * @secure
     */
    updateConversionExchangeRate: (id: string, data: ConversionExchangeRateModel, params: RequestParams = {}) =>
      this.request<ConversionExchangeRateModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/conversion-exchange-rates/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConversionExchangeRates
     * @name AggregationConversionExchangeRate
     * @request POST:/api/conversion-exchange-rates/aggregation
     * @secure
     */
    aggregationConversionExchangeRate: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/conversion-exchange-rates/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConversionExchangeRates
     * @name GetConversionExchangeRateGroupped
     * @request POST:/api/conversion-exchange-rates/groupped
     * @secure
     */
    getConversionExchangeRateGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/conversion-exchange-rates/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ConversionExchangeRates
     * @name GetConversionExchangeRateBatch
     * @request POST:/api/conversion-exchange-rates/{pageIndex},{pageSize}
     * @secure
     */
    getConversionExchangeRateBatch: (
      pageIndex: number,
      pageSize: number,
      data: QueryModel,
      params: RequestParams = {},
    ) =>
      this.request<ConversionExchangeRateModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/conversion-exchange-rates/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Currencies
     * @name DeleteCurrency
     * @request DELETE:/api/currencies
     * @secure
     */
    deleteCurrency: (data: QueryModel, params: RequestParams = {}) =>
      this.request<CurrencyModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/currencies`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Currencies
     * @name InsertCurrency
     * @request POST:/api/currencies
     * @secure
     */
    insertCurrency: (data: CurrencyModel, params: RequestParams = {}) =>
      this.request<CurrencyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/currencies`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Currencies
     * @name GetCurrencyById
     * @request GET:/api/currencies/{id}
     * @secure
     */
    getCurrencyById: (id: string, params: RequestParams = {}) =>
      this.request<CurrencyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/currencies/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Currencies
     * @name PatchCurrency
     * @request PATCH:/api/currencies/{id}
     * @secure
     */
    patchCurrency: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<CurrencyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/currencies/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Currencies
     * @name UpdateCurrency
     * @request PUT:/api/currencies/{id}
     * @secure
     */
    updateCurrency: (id: string, data: CurrencyModel, params: RequestParams = {}) =>
      this.request<CurrencyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/currencies/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Currencies
     * @name AggregationCurrency
     * @request POST:/api/currencies/aggregation
     * @secure
     */
    aggregationCurrency: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/currencies/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Currencies
     * @name GetCurrencyGroupped
     * @request POST:/api/currencies/groupped
     * @secure
     */
    getCurrencyGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/currencies/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Currencies
     * @name GetCurrencyBatch
     * @request POST:/api/currencies/{pageIndex},{pageSize}
     * @secure
     */
    getCurrencyBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<CurrencyModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/currencies/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventParticipants
     * @name DeleteEventParticipants
     * @request DELETE:/api/events-participants
     * @secure
     */
    deleteEventParticipants: (data: QueryModel, params: RequestParams = {}) =>
      this.request<EventParticipantModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events-participants`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventParticipants
     * @name InsertEventParticipant
     * @request POST:/api/events-participants
     * @secure
     */
    insertEventParticipant: (data: EventParticipantModel, params: RequestParams = {}) =>
      this.request<EventParticipantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events-participants`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventParticipants
     * @name GetEventParticipantById
     * @request GET:/api/events-participants/{id}
     * @secure
     */
    getEventParticipantById: (id: string, params: RequestParams = {}) =>
      this.request<EventParticipantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events-participants/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventParticipants
     * @name PatchEventParticipant
     * @request PATCH:/api/events-participants/{id}
     * @secure
     */
    patchEventParticipant: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<EventParticipantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events-participants/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventParticipants
     * @name UpdateEventParticipant
     * @request PUT:/api/events-participants/{id}
     * @secure
     */
    updateEventParticipant: (id: string, data: EventParticipantModel, params: RequestParams = {}) =>
      this.request<EventParticipantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events-participants/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventParticipants
     * @name AggregationEventParticipant
     * @request POST:/api/events-participants/aggregation
     * @secure
     */
    aggregationEventParticipant: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events-participants/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventParticipants
     * @name GetEventParticipantGroupped
     * @request POST:/api/events-participants/groupped
     * @secure
     */
    getEventParticipantGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events-participants/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EventParticipants
     * @name GetEventParticipantBatch
     * @request POST:/api/events-participants/{pageIndex},{pageSize}
     * @secure
     */
    getEventParticipantBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<EventParticipantModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events-participants/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name DeleteEvents
     * @request DELETE:/api/events
     * @secure
     */
    deleteEvents: (data: QueryModel, params: RequestParams = {}) =>
      this.request<EventModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name InsertEvent
     * @request POST:/api/events
     * @secure
     */
    insertEvent: (data: EventModel, params: RequestParams = {}) =>
      this.request<EventModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name GetEventById
     * @request GET:/api/events/{id}
     * @secure
     */
    getEventById: (id: string, params: RequestParams = {}) =>
      this.request<EventModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name PatchEvent
     * @request PATCH:/api/events/{id}
     * @secure
     */
    patchEvent: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<EventModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name UpdateEvent
     * @request PUT:/api/events/{id}
     * @secure
     */
    updateEvent: (id: string, data: EventModel, params: RequestParams = {}) =>
      this.request<EventModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name AggregationEvent
     * @request POST:/api/events/aggregation
     * @secure
     */
    aggregationEvent: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name GetEventGroupped
     * @request POST:/api/events/groupped
     * @secure
     */
    getEventGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name GetEventBatch
     * @request POST:/api/events/{pageIndex},{pageSize}
     * @secure
     */
    getEventBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<EventModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/events/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeRates
     * @name DeleteExchangeRate
     * @request DELETE:/api/exchange-rates
     * @secure
     */
    deleteExchangeRate: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ExchangeRateModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/exchange-rates`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeRates
     * @name InsertExchangeRate
     * @request POST:/api/exchange-rates
     * @secure
     */
    insertExchangeRate: (data: ExchangeRateModel, params: RequestParams = {}) =>
      this.request<ExchangeRateModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/exchange-rates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeRates
     * @name GetExchangeRateById
     * @request GET:/api/exchange-rates/{id}
     * @secure
     */
    getExchangeRateById: (id: string, params: RequestParams = {}) =>
      this.request<ExchangeRateModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/exchange-rates/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeRates
     * @name PatchExchangeRate
     * @request PATCH:/api/exchange-rates/{id}
     * @secure
     */
    patchExchangeRate: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<ExchangeRateModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/exchange-rates/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeRates
     * @name UpdateExchangeRate
     * @request PUT:/api/exchange-rates/{id}
     * @secure
     */
    updateExchangeRate: (id: string, data: ExchangeRateModel, params: RequestParams = {}) =>
      this.request<ExchangeRateModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/exchange-rates/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeRates
     * @name AggregationExchangeRate
     * @request POST:/api/exchange-rates/aggregation
     * @secure
     */
    aggregationExchangeRate: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/exchange-rates/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeRates
     * @name GetExchangeRateGroupped
     * @request POST:/api/exchange-rates/groupped
     * @secure
     */
    getExchangeRateGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/exchange-rates/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeRates
     * @name GetExchangeRateBatch
     * @request POST:/api/exchange-rates/{pageIndex},{pageSize}
     * @secure
     */
    getExchangeRateBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ExchangeRateModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/exchange-rates/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileActivities
     * @name DeleteFileActivities
     * @request DELETE:/api/file-activities
     * @secure
     */
    deleteFileActivities: (data: QueryModel, params: RequestParams = {}) =>
      this.request<FileActivityModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/file-activities`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileActivities
     * @name InsertFileActivity
     * @request POST:/api/file-activities
     * @secure
     */
    insertFileActivity: (data: FileActivityModel, params: RequestParams = {}) =>
      this.request<FileActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/file-activities`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileActivities
     * @name GetFileActivityById
     * @request GET:/api/file-activities/{id}
     * @secure
     */
    getFileActivityById: (id: string, params: RequestParams = {}) =>
      this.request<FileActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/file-activities/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileActivities
     * @name PatchFileActivity
     * @request PATCH:/api/file-activities/{id}
     * @secure
     */
    patchFileActivity: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<FileActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/file-activities/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileActivities
     * @name UpdateFileActivity
     * @request PUT:/api/file-activities/{id}
     * @secure
     */
    updateFileActivity: (id: string, data: FileActivityModel, params: RequestParams = {}) =>
      this.request<FileActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/file-activities/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileActivities
     * @name AggregationFileActivity
     * @request POST:/api/file-activities/aggregation
     * @secure
     */
    aggregationFileActivity: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/file-activities/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileActivities
     * @name GetFileActivityGroupped
     * @request POST:/api/file-activities/groupped
     * @secure
     */
    getFileActivityGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/file-activities/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileActivities
     * @name GetFileActivityBatch
     * @request POST:/api/file-activities/{pageIndex},{pageSize}
     * @secure
     */
    getFileActivityBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileActivityModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/file-activities/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name AzureCopy
     * @request POST:/api/files/copy
     * @secure
     */
    azureCopy: (data: FileCopyModel, params: RequestParams = {}) =>
      this.request<FileModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/copy`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name DeleteFiles
     * @request DELETE:/api/files
     * @secure
     */
    deleteFiles: (data: QueryModel, params: RequestParams = {}) =>
      this.request<FileModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name GetFileById
     * @request GET:/api/files/{id}
     * @secure
     */
    getFileById: (id: string, params: RequestParams = {}) =>
      this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name PatchFile
     * @request PATCH:/api/files/{id}
     * @secure
     */
    patchFile: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name UpdateFile
     * @request PUT:/api/files/{id}
     * @secure
     */
    updateFile: (id: string, data: FileModel, params: RequestParams = {}) =>
      this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name AggregationFile
     * @request POST:/api/files/aggregation
     * @secure
     */
    aggregationFile: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name GetFileGroupped
     * @request POST:/api/files/groupped
     * @secure
     */
    getFileGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name GetFileBatch
     * @request POST:/api/files/{pageIndex},{pageSize}
     * @secure
     */
    getFileBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name DeleteFolders
     * @request DELETE:/api/folders
     * @secure
     */
    deleteFolders: (data: QueryModel, params: RequestParams = {}) =>
      this.request<FolderModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name InsertFolder
     * @request POST:/api/folders
     * @secure
     */
    insertFolder: (data: FolderModel, params: RequestParams = {}) =>
      this.request<FolderModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name GetFolderById
     * @request GET:/api/folders/{id}
     * @secure
     */
    getFolderById: (id: string, params: RequestParams = {}) =>
      this.request<FolderModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name PatchFolder
     * @request PATCH:/api/folders/{id}
     * @secure
     */
    patchFolder: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<FolderModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name UpdateFolder
     * @request PUT:/api/folders/{id}
     * @secure
     */
    updateFolder: (id: string, data: FolderModel, params: RequestParams = {}) =>
      this.request<FolderModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name AggregationFolder
     * @request POST:/api/folders/aggregation
     * @secure
     */
    aggregationFolder: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name GetFolderGroupped
     * @request POST:/api/folders/groupped
     * @secure
     */
    getFolderGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name GetFolderBatch
     * @request POST:/api/folders/{pageIndex},{pageSize}
     * @secure
     */
    getFolderBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FolderModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/folders/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleSheet
     * @name DownloadTransactions
     * @request GET:/api/google-sheet
     * @secure
     */
    downloadTransactions: (params: RequestParams = {}) =>
      this.request<NreiGoogleSheetModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/google-sheet`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name UpdateAvatar
     * @request PUT:/api/me/avatar
     * @secure
     */
    updateAvatar: (data: AvatarUploadModel, params: RequestParams = {}) =>
      this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/me/avatar`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name GetApplicationUser
     * @request GET:/api/me
     * @secure
     */
    getApplicationUser: (params: RequestParams = {}) =>
      this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name UpdateApplicationUser
     * @request PUT:/api/me
     * @secure
     */
    updateApplicationUser: (data: ApplicationUserModel, params: RequestParams = {}) =>
      this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/me`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name UpdateArticleCheck
     * @request PUT:/api/me/update-article-check
     * @secure
     */
    updateArticleCheck: (params: RequestParams = {}) =>
      this.request<PartyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/me/update-article-check`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name DeleteNotifications
     * @request DELETE:/api/notifications
     * @secure
     */
    deleteNotifications: (data: QueryModel, params: RequestParams = {}) =>
      this.request<NotificationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/notifications`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name InsertNotification
     * @request POST:/api/notifications
     * @secure
     */
    insertNotification: (data: NotificationModel, params: RequestParams = {}) =>
      this.request<NotificationModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/notifications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name GetNotificationById
     * @request GET:/api/notifications/{id}
     * @secure
     */
    getNotificationById: (id: string, params: RequestParams = {}) =>
      this.request<NotificationModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/notifications/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name PatchNotification
     * @request PATCH:/api/notifications/{id}
     * @secure
     */
    patchNotification: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<NotificationModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/notifications/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name UpdateNotification
     * @request PUT:/api/notifications/{id}
     * @secure
     */
    updateNotification: (id: string, data: NotificationModel, params: RequestParams = {}) =>
      this.request<NotificationModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/notifications/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name AggregationNotification
     * @request POST:/api/notifications/aggregation
     * @secure
     */
    aggregationNotification: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/notifications/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name GetNotificationGroupped
     * @request POST:/api/notifications/groupped
     * @secure
     */
    getNotificationGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/notifications/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name GetNotificationBatch
     * @request POST:/api/notifications/{pageIndex},{pageSize}
     * @secure
     */
    getNotificationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<NotificationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/notifications/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name DeleteParties
     * @request DELETE:/api/parties
     * @secure
     */
    deleteParties: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name InsertParty
     * @request POST:/api/parties
     * @secure
     */
    insertParty: (data: PartyModel, params: RequestParams = {}) =>
      this.request<PartyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name GetPartyById
     * @request GET:/api/parties/{id}
     * @secure
     */
    getPartyById: (id: string, params: RequestParams = {}) =>
      this.request<PartyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name PatchParty
     * @request PATCH:/api/parties/{id}
     * @secure
     */
    patchParty: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PartyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name UpdateParty
     * @request PUT:/api/parties/{id}
     * @secure
     */
    updateParty: (id: string, data: PartyModel, params: RequestParams = {}) =>
      this.request<PartyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name SendPartyRegistration
     * @request POST:/api/parties/send-party-registration
     * @secure
     */
    sendPartyRegistration: (data: SendPartyRegistrationModel, params: RequestParams = {}) =>
      this.request<PartyModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/send-party-registration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name GetPartyBatch
     * @request POST:/api/parties/{pageIndex},{pageSize}
     * @secure
     */
    getPartyBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parties
     * @name ExportPartyBatch
     * @request POST:/api/parties/{pageIndex},{pageSize}/export
     * @secure
     */
    exportPartyBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/parties/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name DeletePartyActivities
     * @request DELETE:/api/party-comments
     * @secure
     */
    deletePartyActivities: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyActivityModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-comments`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name InsertPartyActivity
     * @request POST:/api/party-comments
     * @secure
     */
    insertPartyActivity: (data: PartyActivityModel, params: RequestParams = {}) =>
      this.request<PartyActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-comments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name GetPartyActivityById
     * @request GET:/api/party-comments/{id}
     * @secure
     */
    getPartyActivityById: (id: string, params: RequestParams = {}) =>
      this.request<PartyActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-comments/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name PatchPartyActivity
     * @request PATCH:/api/party-comments/{id}
     * @secure
     */
    patchPartyActivity: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PartyActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-comments/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name UpdatePartyActivity
     * @request PUT:/api/party-comments/{id}
     * @secure
     */
    updatePartyActivity: (id: string, data: PartyActivityModel, params: RequestParams = {}) =>
      this.request<PartyActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-comments/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name AggregationPartyActivity
     * @request POST:/api/party-comments/aggregation
     * @secure
     */
    aggregationPartyActivity: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-comments/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name GetPartyActivityGroupped
     * @request POST:/api/party-comments/groupped
     * @secure
     */
    getPartyActivityGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-comments/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyActivities
     * @name GetPartyActivityBatch
     * @request POST:/api/party-comments/{pageIndex},{pageSize}
     * @secure
     */
    getPartyActivityBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyActivityModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-comments/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCredits
     * @name DeletePartyCredits
     * @request DELETE:/api/party-credits
     * @secure
     */
    deletePartyCredits: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyCreditModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-credits`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCredits
     * @name InsertPartyCredit
     * @request POST:/api/party-credits
     * @secure
     */
    insertPartyCredit: (data: PartyCreditModel, params: RequestParams = {}) =>
      this.request<PartyCreditModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-credits`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCredits
     * @name GetPartyCreditById
     * @request GET:/api/party-credits/{id}
     * @secure
     */
    getPartyCreditById: (id: string, params: RequestParams = {}) =>
      this.request<PartyCreditModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-credits/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCredits
     * @name PatchPartyCredit
     * @request PATCH:/api/party-credits/{id}
     * @secure
     */
    patchPartyCredit: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PartyCreditModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-credits/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCredits
     * @name UpdatePartyCredit
     * @request PUT:/api/party-credits/{id}
     * @secure
     */
    updatePartyCredit: (id: string, data: PartyCreditModel, params: RequestParams = {}) =>
      this.request<PartyCreditModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-credits/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCredits
     * @name AggregationPartyCredit
     * @request POST:/api/party-credits/aggregation
     * @secure
     */
    aggregationPartyCredit: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-credits/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCredits
     * @name GetPartyCreditGroupped
     * @request POST:/api/party-credits/groupped
     * @secure
     */
    getPartyCreditGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-credits/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCredits
     * @name GetPartyCreditBatch
     * @request POST:/api/party-credits/{pageIndex},{pageSize}
     * @secure
     */
    getPartyCreditBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyCreditModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-credits/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyCredits
     * @name UpdatePartyCreditPdf
     * @request PUT:/api/party-credits/avatar
     * @secure
     */
    updatePartyCreditPdf: (data: PartyCreditUploadModel, params: RequestParams = {}) =>
      this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-credits/avatar`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyProductQuotations
     * @name InsertPartyProductQuotation
     * @request POST:/api/party-product-quotations
     * @secure
     */
    insertPartyProductQuotation: (data: PartyProductQuotationModel, params: RequestParams = {}) =>
      this.request<PartyProductQuotationModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-product-quotations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyProducts
     * @name DeletePartyProducts
     * @request DELETE:/api/party-products
     * @secure
     */
    deletePartyProducts: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyProductModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-products`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyProducts
     * @name InsertPartyProduct
     * @request POST:/api/party-products
     * @secure
     */
    insertPartyProduct: (data: PartyProductModel, params: RequestParams = {}) =>
      this.request<PartyProductModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-products`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyProducts
     * @name GetPartyProductById
     * @request GET:/api/party-products/{id}
     * @secure
     */
    getPartyProductById: (id: string, params: RequestParams = {}) =>
      this.request<PartyProductModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-products/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyProducts
     * @name PatchPartyProduct
     * @request PATCH:/api/party-products/{id}
     * @secure
     */
    patchPartyProduct: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PartyProductModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-products/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyProducts
     * @name UpdatePartyProduct
     * @request PUT:/api/party-products/{id}
     * @secure
     */
    updatePartyProduct: (id: string, data: PartyProductModel, params: RequestParams = {}) =>
      this.request<PartyProductModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-products/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyProducts
     * @name AggregationPartyProduct
     * @request POST:/api/party-products/aggregation
     * @secure
     */
    aggregationPartyProduct: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-products/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyProducts
     * @name GetPartyProductGroupped
     * @request POST:/api/party-products/groupped
     * @secure
     */
    getPartyProductGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-products/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartyProducts
     * @name GetPartyProductBatch
     * @request POST:/api/party-products/{pageIndex},{pageSize}
     * @secure
     */
    getPartyProductBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PartyProductModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/party-products/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductActivities
     * @name DeleteProductActivities
     * @request DELETE:/api/product-comments
     * @secure
     */
    deleteProductActivities: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ProductActivityModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-comments`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductActivities
     * @name InsertProductActivity
     * @request POST:/api/product-comments
     * @secure
     */
    insertProductActivity: (data: ProductActivityModel, params: RequestParams = {}) =>
      this.request<ProductActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-comments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductActivities
     * @name GetProductActivityById
     * @request GET:/api/product-comments/{id}
     * @secure
     */
    getProductActivityById: (id: string, params: RequestParams = {}) =>
      this.request<ProductActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-comments/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductActivities
     * @name PatchProductActivity
     * @request PATCH:/api/product-comments/{id}
     * @secure
     */
    patchProductActivity: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<ProductActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-comments/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductActivities
     * @name UpdateProductActivity
     * @request PUT:/api/product-comments/{id}
     * @secure
     */
    updateProductActivity: (id: string, data: ProductActivityModel, params: RequestParams = {}) =>
      this.request<ProductActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-comments/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductActivities
     * @name AggregationProductActivity
     * @request POST:/api/product-comments/aggregation
     * @secure
     */
    aggregationProductActivity: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-comments/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductActivities
     * @name GetProductActivityGroupped
     * @request POST:/api/product-comments/groupped
     * @secure
     */
    getProductActivityGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-comments/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductActivities
     * @name GetProductActivityBatch
     * @request POST:/api/product-comments/{pageIndex},{pageSize}
     * @secure
     */
    getProductActivityBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ProductActivityModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-comments/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductNotificationRules
     * @name DeleteProductNotificationRules
     * @request DELETE:/api/product-notification-rules
     * @secure
     */
    deleteProductNotificationRules: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ProductNotificationRuleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-notification-rules`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductNotificationRules
     * @name InsertProductNotificationRule
     * @request POST:/api/product-notification-rules
     * @secure
     */
    insertProductNotificationRule: (data: ProductNotificationRuleModel, params: RequestParams = {}) =>
      this.request<ProductNotificationRuleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-notification-rules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductNotificationRules
     * @name GetProductNotificationRuleById
     * @request GET:/api/product-notification-rules/{id}
     * @secure
     */
    getProductNotificationRuleById: (id: string, params: RequestParams = {}) =>
      this.request<ProductNotificationRuleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-notification-rules/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductNotificationRules
     * @name PatchProductNotificationRule
     * @request PATCH:/api/product-notification-rules/{id}
     * @secure
     */
    patchProductNotificationRule: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<ProductNotificationRuleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-notification-rules/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductNotificationRules
     * @name UpdateProductNotificationRule
     * @request PUT:/api/product-notification-rules/{id}
     * @secure
     */
    updateProductNotificationRule: (id: string, data: ProductNotificationRuleModel, params: RequestParams = {}) =>
      this.request<ProductNotificationRuleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-notification-rules/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductNotificationRules
     * @name AggregationProductNotificationRule
     * @request POST:/api/product-notification-rules/aggregation
     * @secure
     */
    aggregationProductNotificationRule: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-notification-rules/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductNotificationRules
     * @name GetProductNotificationRuleGroupped
     * @request POST:/api/product-notification-rules/groupped
     * @secure
     */
    getProductNotificationRuleGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-notification-rules/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductNotificationRules
     * @name GetProductNotificationRuleBatch
     * @request POST:/api/product-notification-rules/{pageIndex},{pageSize}
     * @secure
     */
    getProductNotificationRuleBatch: (
      pageIndex: number,
      pageSize: number,
      data: QueryModel,
      params: RequestParams = {},
    ) =>
      this.request<ProductNotificationRuleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-notification-rules/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name DeleteProducts
     * @request DELETE:/api/products
     * @secure
     */
    deleteProducts: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ProductModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/products`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name InsertProduct
     * @request POST:/api/products
     * @secure
     */
    insertProduct: (data: ProductModel, params: RequestParams = {}) =>
      this.request<ProductModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/products`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name GetProductById
     * @request GET:/api/products/{id}
     * @secure
     */
    getProductById: (id: string, params: RequestParams = {}) =>
      this.request<ProductModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/products/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name PatchProduct
     * @request PATCH:/api/products/{id}
     * @secure
     */
    patchProduct: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<ProductModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/products/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name UpdateProduct
     * @request PUT:/api/products/{id}
     * @secure
     */
    updateProduct: (id: string, data: ProductModel, params: RequestParams = {}) =>
      this.request<ProductModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/products/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name AggregationProduct
     * @request POST:/api/products/aggregation
     * @secure
     */
    aggregationProduct: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/products/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name GetProductGroupped
     * @request POST:/api/products/groupped
     * @secure
     */
    getProductGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/products/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name GetProductBatch
     * @request POST:/api/products/{pageIndex},{pageSize}
     * @secure
     */
    getProductBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ProductModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/products/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductTypes
     * @name DeleteProductTypes
     * @request DELETE:/api/product-types
     * @secure
     */
    deleteProductTypes: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ProductTypeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-types`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductTypes
     * @name InsertProductType
     * @request POST:/api/product-types
     * @secure
     */
    insertProductType: (data: ProductTypeModel, params: RequestParams = {}) =>
      this.request<ProductTypeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-types`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductTypes
     * @name GetProductTypeById
     * @request GET:/api/product-types/{id}
     * @secure
     */
    getProductTypeById: (id: string, params: RequestParams = {}) =>
      this.request<ProductTypeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-types/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductTypes
     * @name PatchProductType
     * @request PATCH:/api/product-types/{id}
     * @secure
     */
    patchProductType: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<ProductTypeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-types/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductTypes
     * @name UpdateProductType
     * @request PUT:/api/product-types/{id}
     * @secure
     */
    updateProductType: (id: string, data: ProductTypeModel, params: RequestParams = {}) =>
      this.request<ProductTypeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-types/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductTypes
     * @name AggregationProductType
     * @request POST:/api/product-types/aggregation
     * @secure
     */
    aggregationProductType: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-types/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductTypes
     * @name GetProductTypeGroupped
     * @request POST:/api/product-types/groupped
     * @secure
     */
    getProductTypeGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-types/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductTypes
     * @name GetProductTypeBatch
     * @request POST:/api/product-types/{pageIndex},{pageSize}
     * @secure
     */
    getProductTypeBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ProductTypeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/product-types/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResetPassword
     * @name ResetPassword
     * @request POST:/api/reset-password
     */
    resetPassword: (data: ResetPasswordModel, params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/reset-password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResetPassword
     * @name ConfirmResetPassword
     * @request POST:/api/reset-password/confirm
     */
    confirmResetPassword: (data: ConfirmResetPasswordModel, params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/reset-password/confirm`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SetPassword
     * @name SetPassword
     * @request POST:/api/set-password
     * @secure
     */
    setPassword: (data: SetPasswordModel, params: RequestParams = {}) =>
      this.request<IdentityResult, void>({
        path: `/api/set-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShareLogs
     * @name GetShareLogById
     * @request GET:/api/shares-logs/{id}
     * @secure
     */
    getShareLogById: (id: string, params: RequestParams = {}) =>
      this.request<ShareLogModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shares-logs/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShareLogs
     * @name AggregationShareLog
     * @request POST:/api/shares-logs/aggregation
     * @secure
     */
    aggregationShareLog: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shares-logs/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShareLogs
     * @name GetShareLogGroupped
     * @request POST:/api/shares-logs/groupped
     * @secure
     */
    getShareLogGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shares-logs/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShareLogs
     * @name ExportShareLogBatch
     * @request POST:/api/shares-logs/{pageIndex},{pageSize}/export
     * @secure
     */
    exportShareLogBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shares-logs/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShareLogs
     * @name GetShareLogBatch
     * @request POST:/api/shares-logs/{pageIndex},{pageSize}
     * @secure
     */
    getShareLogBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ShareLogModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shares-logs/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shares
     * @name GetShareById
     * @request GET:/api/shares/{id}
     * @secure
     */
    getShareById: (id: string, params: RequestParams = {}) =>
      this.request<ShareModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shares/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shares
     * @name AggregationShare
     * @request POST:/api/shares/aggregation
     * @secure
     */
    aggregationShare: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shares/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shares
     * @name GetShareGroupped
     * @request POST:/api/shares/groupped
     * @secure
     */
    getShareGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shares/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shares
     * @name ExportShareBatch
     * @request POST:/api/shares/{pageIndex},{pageSize}/export
     * @secure
     */
    exportShareBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shares/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shares
     * @name GetShareBatch
     * @request POST:/api/shares/{pageIndex},{pageSize}
     * @secure
     */
    getShareBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ShareModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shares/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SignOut
     * @name SignOut
     * @request POST:/api/sign-out
     */
    signOut: (params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/sign-out`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SignUp
     * @name ActivateAccount
     * @request POST:/api/sign-up/confirm
     */
    activateAccount: (data: ConfirmEmailModel, params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/sign-up/confirm`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapital
     * @name DeleteStateOfCapital
     * @request DELETE:/api/state-of-capital
     * @secure
     */
    deleteStateOfCapital: (data: QueryModel, params: RequestParams = {}) =>
      this.request<StateOfCapitalModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapital
     * @name InsertStateOfCapital
     * @request POST:/api/state-of-capital
     * @secure
     */
    insertStateOfCapital: (data: StateOfCapitalModel, params: RequestParams = {}) =>
      this.request<StateOfCapitalModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapital
     * @name GetStateOfCapitalById
     * @request GET:/api/state-of-capital/{id}
     * @secure
     */
    getStateOfCapitalById: (id: string, params: RequestParams = {}) =>
      this.request<StateOfCapitalModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapital
     * @name PatchStateOfCapital
     * @request PATCH:/api/state-of-capital/{id}
     * @secure
     */
    patchStateOfCapital: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<StateOfCapitalModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapital
     * @name UpdateStateOfCapital
     * @request PUT:/api/state-of-capital/{id}
     * @secure
     */
    updateStateOfCapital: (id: string, data: StateOfCapitalModel, params: RequestParams = {}) =>
      this.request<StateOfCapitalModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapital
     * @name AggregationStateOfCapital
     * @request POST:/api/state-of-capital/aggregation
     * @secure
     */
    aggregationStateOfCapital: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapital
     * @name GetStateOfCapitalGroupped
     * @request POST:/api/state-of-capital/groupped
     * @secure
     */
    getStateOfCapitalGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapital
     * @name GetStateOfCapitalBatch
     * @request POST:/api/state-of-capital/{pageIndex},{pageSize}
     * @secure
     */
    getStateOfCapitalBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<StateOfCapitalModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapitalYear
     * @name DeleteStateOfCapitalYear
     * @request DELETE:/api/state-of-capital-years
     * @secure
     */
    deleteStateOfCapitalYear: (data: QueryModel, params: RequestParams = {}) =>
      this.request<StateOfCapitalYearModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital-years`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapitalYear
     * @name InsertStateOfCapitalYear
     * @request POST:/api/state-of-capital-years
     * @secure
     */
    insertStateOfCapitalYear: (data: StateOfCapitalYearModel, params: RequestParams = {}) =>
      this.request<StateOfCapitalYearModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital-years`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapitalYear
     * @name GetStateOfCapitalYearById
     * @request GET:/api/state-of-capital-years/{id}
     * @secure
     */
    getStateOfCapitalYearById: (id: string, params: RequestParams = {}) =>
      this.request<StateOfCapitalYearModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital-years/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapitalYear
     * @name PatchStateOfCapitalYear
     * @request PATCH:/api/state-of-capital-years/{id}
     * @secure
     */
    patchStateOfCapitalYear: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<StateOfCapitalYearModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital-years/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapitalYear
     * @name UpdateStateOfCapitalYear
     * @request PUT:/api/state-of-capital-years/{id}
     * @secure
     */
    updateStateOfCapitalYear: (id: string, data: StateOfCapitalYearModel, params: RequestParams = {}) =>
      this.request<StateOfCapitalYearModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital-years/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapitalYear
     * @name AggregationStateOfCapitalYear
     * @request POST:/api/state-of-capital-years/aggregation
     * @secure
     */
    aggregationStateOfCapitalYear: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital-years/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapitalYear
     * @name GetStateOfCapitalYearGroupped
     * @request POST:/api/state-of-capital-years/groupped
     * @secure
     */
    getStateOfCapitalYearGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital-years/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags StateOfCapitalYear
     * @name GetStateOfCapitalYearBatch
     * @request POST:/api/state-of-capital-years/{pageIndex},{pageSize}
     * @secure
     */
    getStateOfCapitalYearBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<StateOfCapitalYearModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/state-of-capital-years/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trades
     * @name InsertTradeByClient
     * @request POST:/api/trades/client
     * @secure
     */
    insertTradeByClient: (data: TradeRequest, params: RequestParams = {}) =>
      this.request<TradeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/trades/client`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trades
     * @name InsertTradeByConsultant
     * @request POST:/api/trades/consultant
     * @secure
     */
    insertTradeByConsultant: (data: TradeRequest, params: RequestParams = {}) =>
      this.request<TradeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/trades/consultant`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trades
     * @name DeleteTrade
     * @request DELETE:/api/trades
     * @secure
     */
    deleteTrade: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TradeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/trades`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trades
     * @name InsertTrade
     * @request POST:/api/trades
     * @secure
     */
    insertTrade: (data: TradeModel, params: RequestParams = {}) =>
      this.request<TradeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/trades`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trades
     * @name GetTradeById
     * @request GET:/api/trades/{id}
     * @secure
     */
    getTradeById: (id: string, params: RequestParams = {}) =>
      this.request<TradeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/trades/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trades
     * @name PatchTrade
     * @request PATCH:/api/trades/{id}
     * @secure
     */
    patchTrade: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<TradeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/trades/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trades
     * @name UpdateTrade
     * @request PUT:/api/trades/{id}
     * @secure
     */
    updateTrade: (id: string, data: TradeModel, params: RequestParams = {}) =>
      this.request<TradeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/trades/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trades
     * @name AggregationTrade
     * @request POST:/api/trades/aggregation
     * @secure
     */
    aggregationTrade: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/trades/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trades
     * @name GetTradeGroupped
     * @request POST:/api/trades/groupped
     * @secure
     */
    getTradeGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/trades/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trades
     * @name GetTradeBatch
     * @request POST:/api/trades/{pageIndex},{pageSize}
     * @secure
     */
    getTradeBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TradeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/trades/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TransactionEmail
     * @name DeleteTransactionEmail
     * @request DELETE:/api/transaction-emails
     * @secure
     */
    deleteTransactionEmail: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TransactionEmailModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transaction-emails`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TransactionEmail
     * @name InsertTransactionEmail
     * @request POST:/api/transaction-emails
     * @secure
     */
    insertTransactionEmail: (data: TransactionEmailModel, params: RequestParams = {}) =>
      this.request<TransactionEmailModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transaction-emails`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TransactionEmail
     * @name GetTransactionEmailById
     * @request GET:/api/transaction-emails/{id}
     * @secure
     */
    getTransactionEmailById: (id: string, params: RequestParams = {}) =>
      this.request<TransactionEmailModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transaction-emails/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TransactionEmail
     * @name PatchTransactionEmail
     * @request PATCH:/api/transaction-emails/{id}
     * @secure
     */
    patchTransactionEmail: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<TransactionEmailModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transaction-emails/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TransactionEmail
     * @name UpdateTransactionEmail
     * @request PUT:/api/transaction-emails/{id}
     * @secure
     */
    updateTransactionEmail: (id: string, data: TransactionEmailModel, params: RequestParams = {}) =>
      this.request<TransactionEmailModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transaction-emails/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TransactionEmail
     * @name AggregationTransactionEmail
     * @request POST:/api/transaction-emails/aggregation
     * @secure
     */
    aggregationTransactionEmail: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transaction-emails/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TransactionEmail
     * @name GetTransactionEmailGroupped
     * @request POST:/api/transaction-emails/groupped
     * @secure
     */
    getTransactionEmailGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transaction-emails/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TransactionEmail
     * @name GetTransactionEmailBatch
     * @request POST:/api/transaction-emails/{pageIndex},{pageSize}
     * @secure
     */
    getTransactionEmailBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TransactionEmailModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transaction-emails/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name DeleteTransactions
     * @request DELETE:/api/transactions
     * @secure
     */
    deleteTransactions: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TransactionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transactions`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name InsertTransaction
     * @request POST:/api/transactions
     * @secure
     */
    insertTransaction: (data: TransactionModel, params: RequestParams = {}) =>
      this.request<TransactionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transactions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name GetTransactionById
     * @request GET:/api/transactions/{id}
     * @secure
     */
    getTransactionById: (id: string, params: RequestParams = {}) =>
      this.request<TransactionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transactions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name PatchTransaction
     * @request PATCH:/api/transactions/{id}
     * @secure
     */
    patchTransaction: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<TransactionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transactions/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name UpdateTransaction
     * @request PUT:/api/transactions/{id}
     * @secure
     */
    updateTransaction: (id: string, data: TransactionModel, params: RequestParams = {}) =>
      this.request<TransactionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transactions/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name AggregationTransaction
     * @request POST:/api/transactions/aggregation
     * @secure
     */
    aggregationTransaction: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transactions/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name GetTransactionGroupped
     * @request POST:/api/transactions/groupped
     * @secure
     */
    getTransactionGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transactions/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name GetTransactionBatch
     * @request POST:/api/transactions/{pageIndex},{pageSize}
     * @secure
     */
    getTransactionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TransactionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/transactions/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UpdateLog
     * @name DeleteUpdateLog
     * @request DELETE:/api/update-logs
     * @secure
     */
    deleteUpdateLog: (data: QueryModel, params: RequestParams = {}) =>
      this.request<UpdateLogModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/update-logs`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UpdateLog
     * @name InsertUpdateLog
     * @request POST:/api/update-logs
     * @secure
     */
    insertUpdateLog: (data: UpdateLogModel, params: RequestParams = {}) =>
      this.request<UpdateLogModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/update-logs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UpdateLog
     * @name GetUpdateLogById
     * @request GET:/api/update-logs/{id}
     * @secure
     */
    getUpdateLogById: (id: string, params: RequestParams = {}) =>
      this.request<UpdateLogModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/update-logs/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UpdateLog
     * @name PatchUpdateLog
     * @request PATCH:/api/update-logs/{id}
     * @secure
     */
    patchUpdateLog: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<UpdateLogModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/update-logs/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UpdateLog
     * @name UpdateUpdateLog
     * @request PUT:/api/update-logs/{id}
     * @secure
     */
    updateUpdateLog: (id: string, data: UpdateLogModel, params: RequestParams = {}) =>
      this.request<UpdateLogModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/update-logs/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UpdateLog
     * @name AggregationUpdateLog
     * @request POST:/api/update-logs/aggregation
     * @secure
     */
    aggregationUpdateLog: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/update-logs/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UpdateLog
     * @name GetUpdateLogGroupped
     * @request POST:/api/update-logs/groupped
     * @secure
     */
    getUpdateLogGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/update-logs/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UpdateLog
     * @name GetUpdateLogBatch
     * @request POST:/api/update-logs/{pageIndex},{pageSize}
     * @secure
     */
    getUpdateLogBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<UpdateLogModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/update-logs/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTaskActivities
     * @name DeleteUserTaskActivities
     * @request DELETE:/api/user-task-comments
     * @secure
     */
    deleteUserTaskActivities: (data: QueryModel, params: RequestParams = {}) =>
      this.request<UserTaskActivityModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-task-comments`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTaskActivities
     * @name InsertUserTaskActivity
     * @request POST:/api/user-task-comments
     * @secure
     */
    insertUserTaskActivity: (data: UserTaskActivityModel, params: RequestParams = {}) =>
      this.request<UserTaskActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-task-comments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTaskActivities
     * @name GetUserTaskActivityById
     * @request GET:/api/user-task-comments/{id}
     * @secure
     */
    getUserTaskActivityById: (id: string, params: RequestParams = {}) =>
      this.request<UserTaskActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-task-comments/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTaskActivities
     * @name PatchUserTaskActivity
     * @request PATCH:/api/user-task-comments/{id}
     * @secure
     */
    patchUserTaskActivity: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<UserTaskActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-task-comments/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTaskActivities
     * @name UpdateUserTaskActivity
     * @request PUT:/api/user-task-comments/{id}
     * @secure
     */
    updateUserTaskActivity: (id: string, data: UserTaskActivityModel, params: RequestParams = {}) =>
      this.request<UserTaskActivityModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-task-comments/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTaskActivities
     * @name AggregationUserTaskActivity
     * @request POST:/api/user-task-comments/aggregation
     * @secure
     */
    aggregationUserTaskActivity: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-task-comments/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTaskActivities
     * @name GetUserTaskActivityGroupped
     * @request POST:/api/user-task-comments/groupped
     * @secure
     */
    getUserTaskActivityGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-task-comments/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTaskActivities
     * @name GetUserTaskActivityBatch
     * @request POST:/api/user-task-comments/{pageIndex},{pageSize}
     * @secure
     */
    getUserTaskActivityBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<UserTaskActivityModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-task-comments/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTasks
     * @name DeleteUserTasks
     * @request DELETE:/api/user-tasks
     * @secure
     */
    deleteUserTasks: (data: QueryModel, params: RequestParams = {}) =>
      this.request<UserTaskModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-tasks`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTasks
     * @name InsertUserTask
     * @request POST:/api/user-tasks
     * @secure
     */
    insertUserTask: (data: UserTaskModel, params: RequestParams = {}) =>
      this.request<UserTaskModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-tasks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTasks
     * @name GetUserTaskById
     * @request GET:/api/user-tasks/{id}
     * @secure
     */
    getUserTaskById: (id: string, params: RequestParams = {}) =>
      this.request<UserTaskModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-tasks/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTasks
     * @name PatchUserTask
     * @request PATCH:/api/user-tasks/{id}
     * @secure
     */
    patchUserTask: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<UserTaskModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-tasks/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTasks
     * @name UpdateUserTask
     * @request PUT:/api/user-tasks/{id}
     * @secure
     */
    updateUserTask: (id: string, data: UserTaskModel, params: RequestParams = {}) =>
      this.request<UserTaskModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-tasks/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTasks
     * @name AggregationUserTask
     * @request POST:/api/user-tasks/aggregation
     * @secure
     */
    aggregationUserTask: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-tasks/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTasks
     * @name GetUserTaskGroupped
     * @request POST:/api/user-tasks/groupped
     * @secure
     */
    getUserTaskGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-tasks/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTasks
     * @name GetUserTaskBatch
     * @request POST:/api/user-tasks/{pageIndex},{pageSize}
     * @secure
     */
    getUserTaskBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<UserTaskModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-tasks/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserTasks
     * @name ExportUserTaskBatch
     * @request POST:/api/user-tasks/{pageIndex},{pageSize}/export
     * @secure
     */
    exportUserTaskBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-tasks/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wallets
     * @name DeleteWallet
     * @request DELETE:/api/wallets
     * @secure
     */
    deleteWallet: (data: QueryModel, params: RequestParams = {}) =>
      this.request<WalletModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallets`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wallets
     * @name InsertWallet
     * @request POST:/api/wallets
     * @secure
     */
    insertWallet: (data: WalletModel, params: RequestParams = {}) =>
      this.request<WalletModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wallets
     * @name GetWalletById
     * @request GET:/api/wallets/{id}
     * @secure
     */
    getWalletById: (id: string, params: RequestParams = {}) =>
      this.request<WalletModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallets/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wallets
     * @name PatchWallet
     * @request PATCH:/api/wallets/{id}
     * @secure
     */
    patchWallet: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<WalletModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallets/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wallets
     * @name UpdateWallet
     * @request PUT:/api/wallets/{id}
     * @secure
     */
    updateWallet: (id: string, data: WalletModel, params: RequestParams = {}) =>
      this.request<WalletModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallets/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wallets
     * @name AggregationWallet
     * @request POST:/api/wallets/aggregation
     * @secure
     */
    aggregationWallet: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallets/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wallets
     * @name GetWalletGroupped
     * @request POST:/api/wallets/groupped
     * @secure
     */
    getWalletGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallets/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wallets
     * @name GetWalletBatch
     * @request POST:/api/wallets/{pageIndex},{pageSize}
     * @secure
     */
    getWalletBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<WalletModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallets/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WalletTransactions
     * @name DeleteWalletTransaction
     * @request DELETE:/api/wallet-transactions
     * @secure
     */
    deleteWalletTransaction: (data: QueryModel, params: RequestParams = {}) =>
      this.request<WalletTransactionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallet-transactions`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WalletTransactions
     * @name InsertWalletTransaction
     * @request POST:/api/wallet-transactions
     * @secure
     */
    insertWalletTransaction: (data: WalletTransactionModel, params: RequestParams = {}) =>
      this.request<WalletTransactionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallet-transactions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WalletTransactions
     * @name GetWalletTransactionById
     * @request GET:/api/wallet-transactions/{id}
     * @secure
     */
    getWalletTransactionById: (id: string, params: RequestParams = {}) =>
      this.request<WalletTransactionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallet-transactions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WalletTransactions
     * @name PatchWalletTransaction
     * @request PATCH:/api/wallet-transactions/{id}
     * @secure
     */
    patchWalletTransaction: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<WalletTransactionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallet-transactions/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WalletTransactions
     * @name UpdateWalletTransaction
     * @request PUT:/api/wallet-transactions/{id}
     * @secure
     */
    updateWalletTransaction: (id: string, data: WalletTransactionModel, params: RequestParams = {}) =>
      this.request<WalletTransactionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallet-transactions/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WalletTransactions
     * @name AggregationWalletTransaction
     * @request POST:/api/wallet-transactions/aggregation
     * @secure
     */
    aggregationWalletTransaction: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallet-transactions/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WalletTransactions
     * @name GetWalletTransactionGroupped
     * @request POST:/api/wallet-transactions/groupped
     * @secure
     */
    getWalletTransactionGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallet-transactions/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WalletTransactions
     * @name GetWalletTransactionBatch
     * @request POST:/api/wallet-transactions/{pageIndex},{pageSize}
     * @secure
     */
    getWalletTransactionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<WalletTransactionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/wallet-transactions/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
